var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-group",
    {
      attrs: {
        "prepend-icon": "tune",
        "active-class": "activeLinkGroup",
        "no-action": "",
      },
    },
    [
      _c(
        "v-list-tile",
        { attrs: { slot: "activator" }, slot: "activator" },
        [_c("v-list-tile-title", [_vm._v(_vm._s(_vm.$t("App.Manage")))])],
        1
      ),
      _vm._v(" "),
      _vm.isAuthed && _vm.isTenantAdmin
        ? _c(
            "v-list",
            { attrs: { dense: "", dark: "" } },
            [
              _c(
                "v-subheader",
                { staticClass: "mt-3", staticStyle: { height: "unset" } },
                [_vm._v("Discrete Data:")]
              ),
              _vm._v(" "),
              _vm.hasSampleData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        ripple: "",
                        to: {
                          name: "analytesManage",
                          params: { name: _vm.currentUserGroup.name },
                        },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.$t("App.Analytes"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("group_work")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasSampleData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        ripple: "",
                        to: {
                          name: "depthHeightDatums",
                          params: {
                            name:
                              _vm.currentUserGroup && _vm.currentUserGroup.name,
                          },
                        },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.$t("App.depthHeightDatums"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("height")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasSampleData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        ripple: "",
                        to: {
                          name: "flagsManage",
                          params: { tenant: _vm.currentUserGroup.name },
                        },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.$t("App.DiscreteSampleFlags"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("flag")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasSampleData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        ripple: "",
                        to: {
                          name: "guidelinesCofactorEntrance",
                          params: { name: _vm.currentUserGroup.name },
                        },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          _vm._s(_vm.$t("App.guidelinesCofactorEntrance"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("rule")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-subheader",
                { staticClass: "mt-3", staticStyle: { height: "unset" } },
                [_vm._v("Continuous Data:")]
              ),
              _vm._v(" "),
              _vm.hasContinuousData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        to: { name: "continuousDataOutputTenantManage" },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v("Continuous Data Approval, Grades & Qualifier"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("waterfall_chart")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasSurveyData
                ? _c(
                    "v-subheader",
                    { staticClass: "mt-3", staticStyle: { height: "unset" } },
                    [_vm._v("Survey Data:")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasSurveyData
                ? _c(
                    "v-list-tile",
                    {
                      attrs: {
                        to: { name: "ecosurveyingestionsmanage" },
                        "active-class": "activeLink",
                      },
                    },
                    [
                      _c("v-list-tile-title", [
                        _vm._v("EcoSurvey EDD File Schemas"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("mdi-application")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-subheader",
                { staticClass: "mt-3", staticStyle: { height: "unset" } },
                [_vm._v("Other:")]
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                {
                  attrs: {
                    to: { name: "fileschemasmanage" },
                    ripple: "",
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm.$t("App.FileSchemas"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("integration_instructions")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                {
                  attrs: {
                    to: { name: "managemonitoringfeatures" },
                    ripple: "",
                    "active-class": "activeLink",
                  },
                },
                [
                  _c("v-list-tile-title", [_vm._v("Monitoring Locations")]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("satellite")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }